{
  "orderList": {
    "overview": {
      "title": "Overview"
    },
    "addOrder": "Add Order",
    "table": {
      "title": "Orders",
      "search": "Search",
      "filter": "Filter",
      "clearAll": "Clear all",
      "columns": {
        "orderId": "Order ID",
        "serviceLoanNumber": "Servicer Loan Number",
        "client": "Client",
        "vendor": "Vendor",
        "status": "Status",
        "type": "Type",
        "createDate": "Create Date",
        "dueDate": "Client Due Date",
        "slaStatus": "Client SLA Status",
        "requestedDeadlineDate": "Req. Deadline",
        "requestedDeadlineStatus": "Deadline Status",
        "orderUID": "Order UID"
      },
      "filters": {
        "vendor": "Vendor",
        "client": "Client",
        "type": "Order Type",
        "status": "Order Status",
        "slaStatus": "Client SLA Status"
      },
      "emptyState": {
        "title": "No orders found.",
        "descriptionWithFilters": "Try adjusting your filters or search criteria.",
        "descriptionNoData": "There are no orders to display at this time."
      }
    }
  }
}
